import Page from "webPage/Page";
import Gallery from "base/Gallery";
import "magnific-popup";

Page.register(new RegExp('^/news/([a-z0-9\\-_]+)/?$'), () => {

    $('.js-video-popup').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: true,
        image: {
            verticalFit: true
        },
        fixedContentPos: true
    });

    let gallery = new Gallery($('.js-gallery'), {
        pipClass: "pagination__button",
        animationDuration: 700,
    });

    gallery.on('transitionStart', (e) => {
        let active = e.to;
        let totalWidth = $('.js-pips').outerWidth()
        let itemWidth = $('.pagination__button').outerWidth();
        let containerWidth = $('.gallery__preview').outerWidth();
        let maxLeft = totalWidth - containerWidth;
        let left = 0;

        if (active === 0) {
            left = 0;
        } else {
            left = Math.min(maxLeft, active * itemWidth);
        }

        $('.js-pips').css({'transform': 'translateX(-' + left + 'px'});

    });

});
